module.exports = __webpack_public_path__ + "static/media/rotate-exclamation.77122914.svg";